import { startCase, toLower } from 'lodash';
export interface NameUtil {
  getFullName: (firstName: string, middleName: string, lastName: string) => string;
}

export function useName(): NameUtil {
  const getFullName = (firstName: string, middleName: string, lastName: string): string => {
    return startCase(toLower(`${firstName} ${middleName} ${lastName}`));
  };

  return { getFullName: getFullName };
}
